export function plural(number, words) {
    return number + ' ' +words[(number % 100 > 4 && number % 100 < 20) ? 2 : [2, 0, 1, 1, 1, 2][(number % 10 < 5) ? Math.abs(number) % 10 : 5]];
}

export function cloudPaymentsPayWidget(apiKey, invoiceId, amount, currency, clientId, email, JsonData = {}) {
    // eslint-disable-next-line no-undef
    const widget = new cp.CloudPayments()
    return new Promise((resolve) => {
        widget.pay('charge',
            {
                publicId: apiKey,
                description: 'Покупка в личном кабинете FitBase',
                amount: amount,
                currency: currency,
                email: email,
                accountId: clientId,
                invoiceId: invoiceId,
                autoClose: 3,
                data: JsonData
            },
            {
                onSuccess() {
                    resolve(true)
                },
                onFail(reason) {
                    console.log('fail payment', reason)
                    resolve(false)
                },
            }
        )
    })
}

export function payselectionPayWidget(invoiceId, amount, currency, clientId, email, JsonData = {}) {
    // eslint-disable-next-line no-undef
    const widget = new pw.PayWidget();
    return new Promise((resolve) => {
        console.log(JsonData, 'JsonData');
        let paymentData =   {
            MetaData: {
                PaymentType: "Pay",
            },
            PaymentRequest: {
                OrderId: invoiceId.toString(),
                Amount: amount.toString(),
                Currency: currency,
                Description: 'Покупка в личном кабинете FitBase',
            },
            CustomerInfo: {
                UserId: clientId.toString(),
                Email: email ? email : undefined,
                ReceiptEmail: email ? email : undefined,
            },
        };
        if (JsonData.receiptData) {
            paymentData.ReceiptData = JsonData.receiptData;
        }

        console.log({
            serviceId: JsonData.serviceId,
            key: JsonData.publicKey,
            only2Level: JsonData.only2Level,
            paymentData: paymentData,
        }, 'payselection widget data');

        widget.pay(
            {
                serviceId: JsonData.serviceId,
                key: JsonData.publicKey,
                // logger:true,
            },
            paymentData,
            {
                onSuccess: function(res) {
                    console.log("onSuccess from shop", res);
                    resolve(true);
                },
                onError: function(res) {
                    console.log("onFail from shop", res);
                    resolve(false);
                },
                onClose: function(res) {
                    console.log("onClose from shop", res);
                    resolve(false);
                },
            },
            // необязательный параметр, необходим для корректной работы при наличии сайтов с поддоменами
            {only2Level: JsonData.only2Level}
        );
    });
}

export function tipTopPayWidget(invoiceId, amount, currency, clientId, email, JsonData = {}) {
    // eslint-disable-next-line no-undef
    const widget = new tiptop.Widget()
    return new Promise((resolve) => {
        widget.pay('charge',
            {
                publicId: JsonData.publicKey,
                description: 'Покупка в личном кабинете FitBase',
                amount: amount,
                currency: currency,
                email: email,
                accountId: clientId,
                invoiceId: invoiceId,
                autoClose: 3,
                data: JsonData
            },
            {
                onSuccess() {
                    resolve(true)
                },
                onFail(reason) {
                    console.log('fail payment', reason)
                    resolve(false)
                },
            }
        )
    })
}